import { EXCEL_MIMES } from '../config/variables';
import { ContentDocumentSchema } from '../definitions/schemas';

// We use 1000 to match https://www.npmjs.com/package/filesize
const EXCEL_MAX_FILESIZE = 25 * 1000 * 1000;

export const isEmbeddableSpreadsheet = (document: ContentDocumentSchema) => {
  const { filesize, mime } = document;

  /**
   * Excel viewer is shown if:
   * - The document mime matches Excel mimes
   * - We known the document size and is under 25 MB
   */
  return !!(
    EXCEL_MIMES.includes(mime) &&
    filesize &&
    filesize < EXCEL_MAX_FILESIZE
  );
};
